<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column label="ページ" 　align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.page }}</span>
        </template>
      </el-table-column>

      <el-table-column label="人数" 　align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.noOfPrint }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{ $t("general.print") }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!--adding new-->

    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="70%"
      :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="11rem" class="demo-inputForm"
        size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=100>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date"
                style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')"
                :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="備考:">
              <el-input v-model="inputForm.remark" prefix-icon="el-icon-edit" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="ページ:" prop="page">
              <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.page" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="人数:">
              <el-radio-group v-model="inputForm.noOfPrint">
                <el-radio :label="1"></el-radio>
                <el-radio :label="2"></el-radio>
                <el-radio :label="3"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-collapse accordion>
          <el-collapse-item title="社員１" name="1">
            <el-row :gutter=50 style="margin-left: 0.5%; margin-right: 0.5%;">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id1">
                  <el-select v-model="inputForm.employee_id1" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                      :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.inaugural_type_code') + ':'" prop="inauguralType">
                  <el-select v-model="inputForm.inauguralType1" :placeholder="$t('general.select')" clearable
                    size="mini" style="width: 100%">
                    <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_amount') + ':'" prop="salary_amount">
                  <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.salaryAmount1" size="mini"
                    style="width: 80%" placeholder="1000" :maxlength=4>
                  </el-input>
                  {{$t("empIns4.thousand")}}
                </el-form-item>
              </el-col>
              <el-col :md=12>

                <el-form-item :label="$t('empList.name') + ':'" prop="employee_id1">
                  <el-select v-model="inputForm.employee_id1" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="派遣・請負就労:">
                  <el-checkbox v-model="inputForm.consign1"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_type_code') + ':'" prop="salaryType">
                  <el-select v-model="inputForm.salaryType1" :placeholder="$t('general.select')" clearable size="mini"
                    style="width: 100%">
                    <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

          </el-collapse-item>

          <el-collapse-item title="社員２" name="2" v-if="inputForm.noOfPrint>1">
            <el-row :gutter=50 style="margin-left: 0.5%; margin-right: 0.5%;">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id2">
                  <el-select v-model="inputForm.employee_id2" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                      :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.inaugural_type_code') + ':'" prop="inauguralType">
                  <el-select v-model="inputForm.inauguralType2" :placeholder="$t('general.select')" clearable
                    size="mini" style="width: 100%">
                    <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_amount') + ':'" prop="salary_amount">
                  <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.salaryAmount2" size="mini"
                    style="width: 80%" placeholder="1000" :maxlength=4>
                  </el-input>
                  {{$t("empIns4.thousand")}}
                </el-form-item>
              </el-col>
              <el-col :md=12>

                <el-form-item :label="$t('empList.name') + ':'" prop="employee_id2">
                  <el-select v-model="inputForm.employee_id2" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="派遣・請負就労:">
                  <el-checkbox v-model="inputForm.consign2"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_type_code') + ':'" prop="salaryType">
                  <el-select v-model="inputForm.salaryType2" :placeholder="$t('general.select')" clearable size="mini"
                    style="width: 100%">
                    <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

          </el-collapse-item>

          <el-collapse-item title="社員３" name="3" v-if="inputForm.noOfPrint>2">
            <el-row :gutter=50 style="margin-left: 0.5%; margin-right: 0.5%;">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id3">
                  <el-select v-model="inputForm.employee_id3" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                      :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.inaugural_type_code') + ':'" prop="inauguralType">
                  <el-select v-model="inputForm.inauguralType3" :placeholder="$t('general.select')" clearable
                    size="mini" style="width: 100%">
                    <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_amount') + ':'" prop="salary_amount">
                  <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.salaryAmount3" size="mini"
                    style="width: 80%" placeholder="1000" :maxlength=4>
                  </el-input>
                  {{$t("empIns4.thousand")}}
                </el-form-item>
              </el-col>
              <el-col :md=12>

                <el-form-item :label="$t('empList.name') + ':'" prop="employee_id3">
                  <el-select v-model="inputForm.employee_id3" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="派遣・請負就労:">
                  <el-checkbox v-model="inputForm.consign3"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_type_code') + ':'" prop="salaryType">
                  <el-select v-model="inputForm.salaryType3" :placeholder="$t('general.select')" clearable size="mini"
                    style="width: 100%">
                    <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->

    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="70%"
      :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="11rem" class="demo-inputForm"
        size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=100>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date"
                style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" size="mini" :empty-text="$t('general.empty_data')"
                :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id" disabled>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="備考:">
              <el-input v-model="inputForm.remark" prefix-icon="el-icon-edit" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="ページ:" prop="page">
              <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.page" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="人数:">
              <el-radio-group v-model="inputForm.noOfPrint">
                <el-radio :label="1"></el-radio>
                <el-radio :label="2"></el-radio>
                <el-radio :label="3"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-collapse accordion>
          <el-collapse-item title="社員１" name="1">
            <el-row :gutter=50 style="margin-left: 0.5%; margin-right: 0.5%;">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id1">
                  <el-select v-model="inputForm.employee_id1" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                      :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.inaugural_type_code') + ':'" prop="inauguralType">
                  <el-select v-model="inputForm.inauguralType1" :placeholder="$t('general.select')" clearable
                    size="mini" style="width: 100%">
                    <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_amount') + ':'" prop="salary_amount">
                  <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.salaryAmount1" size="mini"
                    style="width: 80%" placeholder="1000" :maxlength=4>
                  </el-input>
                  {{$t("empIns4.thousand")}}
                </el-form-item>
              </el-col>
              <el-col :md=12>

                <el-form-item :label="$t('empList.name') + ':'" prop="employee_id1">
                  <el-select v-model="inputForm.employee_id1" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="派遣・請負就労:">
                  <el-checkbox v-model="inputForm.consign1"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_type_code') + ':'" prop="salaryType">
                  <el-select v-model="inputForm.salaryType1" :placeholder="$t('general.select')" clearable size="mini"
                    style="width: 100%">
                    <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

          </el-collapse-item>

          <el-collapse-item title="社員２" name="2" v-if="inputForm.noOfPrint>1">
            <el-row :gutter=50 style="margin-left: 0.5%; margin-right: 0.5%;">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id2">
                  <el-select v-model="inputForm.employee_id2" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                      :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.inaugural_type_code') + ':'" prop="inauguralType">
                  <el-select v-model="inputForm.inauguralType2" :placeholder="$t('general.select')" clearable
                    size="mini" style="width: 100%">
                    <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_amount') + ':'" prop="salary_amount">
                  <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.salaryAmount2" size="mini"
                    style="width: 80%" placeholder="1000" :maxlength=4>
                  </el-input>
                  {{$t("empIns4.thousand")}}
                </el-form-item>
              </el-col>
              <el-col :md=12>

                <el-form-item :label="$t('empList.name') + ':'" prop="employee_id2">
                  <el-select v-model="inputForm.employee_id2" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="派遣・請負就労:">
                  <el-checkbox v-model="inputForm.consign2"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_type_code') + ':'" prop="salaryType">
                  <el-select v-model="inputForm.salaryType2" :placeholder="$t('general.select')" clearable size="mini"
                    style="width: 100%">
                    <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

          </el-collapse-item>

          <el-collapse-item title="社員３" name="3" v-if="inputForm.noOfPrint>2">
            <el-row :gutter=50 style="margin-left: 0.5%; margin-right: 0.5%;">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id3">
                  <el-select v-model="inputForm.employee_id3" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                      :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.inaugural_type_code') + ':'" prop="inauguralType">
                  <el-select v-model="inputForm.inauguralType3" :placeholder="$t('general.select')" clearable
                    size="mini" style="width: 100%">
                    <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_amount') + ':'" prop="salary_amount">
                  <el-input prefix-icon="el-icon-edit" v-model.number="inputForm.salaryAmount3" size="mini"
                    style="width: 80%" placeholder="1000" :maxlength=4>
                  </el-input>
                  {{$t("empIns4.thousand")}}
                </el-form-item>
              </el-col>
              <el-col :md=12>

                <el-form-item :label="$t('empList.name') + ':'" prop="employee_id3">
                  <el-select v-model="inputForm.employee_id3" clearable size="mini"
                    :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')"
                    style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="派遣・請負就労:">
                  <el-checkbox v-model="inputForm.consign3"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('empIns4.salary_type_code') + ':'" prop="salaryType">
                  <el-select v-model="inputForm.salaryType3" :placeholder="$t('general.select')" clearable size="mini"
                    style="width: 100%">
                    <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <div style="text-align: left; margin-top: 50vh; font-size: smaller; width: fit-content; ">

      <el-card style="background-color: #51d1ff1c;">
        注意
        <ul>
          <li>
            この帳票は、「
            <el-link @click="jump('empIns3NewSummary')">
              雇用保険被保険者資格取得届（連記式）総括票
            </el-link>
            」と合わせて使用すること。
          </li>
        </ul>
      </el-card>

    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,

        labelPosition: "left",

        tableData: [],
        companyInfo: [],
        empList: [{
          id: "",
          employee_id: "",
          name: ""
        }],

        dialogVisible: false,
        dialogEdit: false,

        inputForm: {
          id: "",
          company_id: "",
          page: "",
          date: "",
          remark: "",
          noOfPrint: 1,

          employee_id1: "",
          salaryType1: "",
          salaryAmount1: "",
          inauguralType1: "",
          consign1: false,

          employee_id2: "",
          salaryType2: "",
          salaryAmount2: "",
          inauguralType2: "",
          consign2: false,

          employee_id3: "",
          salaryType3: "",
          salaryAmount3: "",
          inauguralType3: "",
          consign3: false,

        },

        rules: {
          company_id: [{
            required: true,
            message: this.$t("general.please_select"),
            trigger: "blur",
          },],
          date: [{
            required: true,
            message: this.$t("general.please_select"),
            trigger: "blur",
          },],
          employee_id1: [{
            required: true,
            message: this.$t("general.please_select"),
            trigger: "blur",
          },],
          employee_id2: [{
            required: true,
            message: this.$t("general.please_select"),
            trigger: "blur",
          },],
          employee_id3: [{
            required: true,
            message: this.$t("general.please_select"),
            trigger: "blur",
          },],
          page: [{
            required: true,
            message: this.$t("general.inputinfo"),
            trigger: "blur",
          },],
        },

        salary_type: [{
          //月給
          value: "1",
          label: this.$t("empIns4.monthly"),
        },
        {
          //週給
          value: "2",
          label: this.$t("empIns4.weekly"),
        },
        {
          //日給
          value: "3",
          label: this.$t("empIns4.dailypay"),
        },
        {
          //時間給
          value: "4",
          label: this.$t("empIns4.hourly"),
        },
        {
          //その他
          value: "5",
          label: this.$t("general.other"),
        }
        ],

        inaugural_type: [{
          //安定所紹介
          value: "1",
          label: this.$t("empIns4.stable_company"),
        },
        {
          //自己就職
          value: "2",
          label: this.$t("empIns4.self_employment"),
        },
        {
          //民間紹介
          value: "3",
          label: this.$t("empIns4.private_sector"),
        },
        {
          //把握していない
          value: "4",
          label: this.$t("empIns4.not_grasp"),
        }
        ],

      }
    },

    methods: {

      preview(row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open(
          "/pdf/雇用保険被保険者資格取得届（連記式）個人別票-" + row.date + "-" + row.page + "ページ" + row.noOfPrint + "人.pdf"
        );
      },

      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
          method: "post",
          url: "/empIns3NewSubmissionPDF",
          data: postData
        })
          .then((response) => {
            if (response.data.status = "success") {
              this.$message({
                type: "success",
                message: this.$t("general.print_completed")
              });
              setTimeout(() => {
                this.preview(row);
              }, 300);
            } else {
              this.$message({
                type: "warning",
                message: this.$t("general.print_failed")
              });
            }
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          });
      },

      add(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              company_id: this.inputForm.company_id,
              page: this.inputForm.page,
              date: this.inputForm.date,
              remark: this.inputForm.remark,
              noOfPrint: this.inputForm.noOfPrint,

              employee_id1: this.inputForm.employee_id1,
              salaryType1: this.inputForm.salaryType1,
              salaryAmount1: this.inputForm.salaryAmount1,
              inauguralType1: this.inputForm.inauguralType1,
              consign1: this.inputForm.consign1,

              employee_id2: this.inputForm.employee_id2,
              salaryType2: this.inputForm.salaryType2,
              salaryAmount2: this.inputForm.salaryAmount2,
              inauguralType2: this.inputForm.inauguralType2,
              consign2: this.inputForm.consign2,

              employee_id3: this.inputForm.employee_id3,
              salaryType3: this.inputForm.salaryType3,
              salaryAmount3: this.inputForm.salaryAmount3,
              inauguralType3: this.inputForm.inauguralType3,
              consign3: this.inputForm.consign3

            });
            this.axios({
              method: "post",
              url: "/insertEmpIns3NewSubmission",
              data: postData
            })
              .then(response => {
                this.$message({
                  type: "success",
                  message: this.$t("general.add_completed")
                });
                this.currentPage = 1;
                this.getPages();
                this.dialogVisible = false;
                this.emptyForm();
              })
              .catch(error => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.add_failed")
                });
                console.log(error);
              });
          } else {
            // console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },

      handleEdit(index, row) {
        this.dialogEdit = true;
        this.inputForm = Object.assign({}, row);
      },

      edit(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.inputForm.id,
              page: this.inputForm.page,
              date: this.inputForm.date,
              remark: this.inputForm.remark,
              noOfPrint: this.inputForm.noOfPrint,

              employee_id1: this.inputForm.employee_id1,
              salaryType1: this.inputForm.salaryType1,
              salaryAmount1: this.inputForm.salaryAmount1,
              inauguralType1: this.inputForm.inauguralType1,
              consign1: this.inputForm.consign1,

              employee_id2: this.inputForm.employee_id2,
              salaryType2: this.inputForm.salaryType2,
              salaryAmount2: this.inputForm.salaryAmount2,
              inauguralType2: this.inputForm.inauguralType2,
              consign2: this.inputForm.consign2,

              employee_id3: this.inputForm.employee_id3,
              salaryType3: this.inputForm.salaryType3,
              salaryAmount3: this.inputForm.salaryAmount3,
              inauguralType3: this.inputForm.inauguralType3,
              consign3: this.inputForm.consign3
            });
            this.axios({
              method: "post",
              url: "/updateEmpIns3NewSubmission",
              data: postData
            })
              .then(response => {
                this.handleCurrentChange();
                this.dialogEdit = false;
                this.emptyForm();
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });

              })
              .catch(error => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },


      handleDelete(index, row) {
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
              method: "post",
              url: "/deleteEmpIns3NewSubmission",
              data: postData
            })
              .then(response => {
                this.getPages();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },

      emptyForm() {
        this.inputForm = {
          id: "",
          company_id: "",
          page: "",
          date: "",
          remark: "",
          noOfPrint: 1,

          employee_id1: "",
          salaryType1: "",
          salaryAmount1: "",
          inauguralType1: "",
          consign1: false,

          employee_id2: "",
          salaryType2: "",
          salaryAmount2: "",
          inauguralType2: "",
          consign2: false,

          employee_id3: "",
          salaryType3: "",
          salaryAmount3: "",
          inauguralType3: "",
          consign3: false,
        }
        this.$refs['inputForm'].resetFields(); //to reset rule // must use emptyForm cus cant reset fields

      },


      jump(path) {
        this.$router.push(path);
      },

      cancel() {
        this.dialogVisible = false;
        this.dialogEdit = false;
        this.emptyForm();
      },

      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            done();
            this.emptyForm();
          })
          .catch(_ => { });
      },

      handleCurrentChange() {
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
          method: "post",
          url: "/pageEmpIns3NewSubmission",
          data: postData
        })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },

      getPages() {
        this.axios
          .post("/pageEmpIns3NewSubmission")
          .then(response => {
            this.show = true
            this.tableData = response.data;
          })
          .catch(error => {
            // this.show = false;
            // this.$message({
            //     type: 'error',
            //     message: '開発中です。'
            // });
            console.log(error);
          });
        this.axios
          .post("/rowsEmpIns3NewSubmission")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },

    },

    created() {
      this.getPages();

      //get Company List
      this.axios
        .post("/ListComInfo")
        .then((response) => {
          this.companyInfo = response.data;
          console.log(this.companyInfo);
        })
        .catch((error) => {
          console.log(error);
        });

      //get Employee Name
      this.axios
        .post("/ListEmpListForInsNameChange")
        .then(response => {
          this.empList = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }


  }
</script>

<style scoped>
  .style1 {
    margin-right: 100px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns3NewSubmission.vue